import type { Zone, Stop } from "../types";
export function fitBoundsForZones(map: google.maps.Map, zones: Zone[]) {
  const bounds = new google.maps.LatLngBounds();
  zones.forEach((z) => z.polygon.forEach((pt) => bounds.extend(pt)));
  map.fitBounds(bounds, 60);
}
export function fitBoundsForStops(
  map: google.maps.Map,
  stops: Stop[],
  maxZoom = 15
) {
  if (!map || stops.length === 0) return;

  if (stops.length === 1) {
    map.panTo({ lat: stops[0].lat, lng: stops[0].lng });
    map.setZoom(maxZoom);
    return;
  }

  const bounds = new google.maps.LatLngBounds();
  stops.forEach((s) => bounds.extend({ lat: s.lat, lng: s.lng }));

  map.fitBounds(bounds, 60);

  google.maps.event.addListenerOnce(map, "idle", () => {
    const zoom = map.getZoom();

    if (zoom != null && zoom > maxZoom) {
      map.setZoom(maxZoom);
    }
  });
}
